module.exports = ".success-toast {\n  color: green;\n}\n"